"use strict";

const normalPriceCoeff = 10000; // FIXME

export default class MoneyUtil {

  static formatMoney( value, curr )  {
    if ( !isFinite(value) )
      return "";

    let sval = ""+(Math.round(value)+99);

    let sign = "";
    if (sval[0] == "-")
    {
      sign = "-";
      sval = sval.slice(1);
    }

    if ( sval.length <= 4 )
      sval = ("0000"+sval).slice(-5);

    const moneyString = sign+sval.slice(0, sval.length-4)+"."+sval.slice(-4,-2);
    const currString = curr ? " " + this.formatCurr(curr) : "";

    return moneyString + currString;
  }

  // Market is GJN-only; former wallet FX path was always usd→gjn at rate 1.
  static preferMoney( normalPrice, localPrice, priceCurr, userCurr )
  {
    if (!userCurr)
      userCurr = SettingsInjections.getUsedCurrency().market;

    if (priceCurr == userCurr && localPrice)
      return localPrice;

    return (normalPrice || 0) / normalPriceCoeff;
  }

  static formatCurr( curr ) {
    const currencies = {
      'rub': '\u0440',
      'usd': '$',
      'eur': '\u20AC',
      'gbp': '\u00A3',
      'brl': 'R$',
      'jpy': '\u00A5',
      'nok': 'kr',
      'inr': 'Rs',
      'myr': 'RM',
      'php': '\u20B1',
      'sgd': 'S$',
      'thb': '\u0E3F',
      'krw': '\\',
      'try': '\u20BA',
      'uah': '\u20B4',
      'mxn': 'Mex$',
      'cad': 'C$',
      'aud': 'A$',
      'nzd': 'NZ$',
      'idr': 'Rp',
      'chf': 'Fr.',
      'cny': 'CN\u00A5',
      'clp': 'CLP$',
      'pen': 'S/',
      'cop': 'COL$',
      'zar': 'R',
      'twd': 'NT$',
      'sar': 'SR',
      'hkd': 'HK$',
      'aed': 'Dhs',
      'vnd': '\u20AB',
      'byn': 'Br',
      'pln': 'zł',
      'gjn': 'GJN'
    };

    return currencies[curr] ? currencies[curr] : curr;
  }

  static parseMoney( value )  {
    value = value || "";
    if ( value == "" )
      return NaN;

    const m = (/^\s*(\d*)(?:\.(\d*))?\s*$/).exec( value );
    if ( ! (m && (m[1] || m[2]) ) )
      return NaN;

    const hi = (m[1] || "0");
    const lo = ( ( (m[2] || "0") + "0000" ).slice(0,2) + "0000"  ).slice(0,4);
    return parseInt( (hi+lo), 10 );
  }
};


